"use client";

import IconSparkles from "@/app/(components)/generics/Icons/IconSparkles";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { PageParams } from "@/app/types/common/DefaultProps";
import styles from "../../AvatarDetail.module.css";
import cardStyles from "../AvatarDetailCard/AvatarDetailCard.module.css";

type Props = {
  params: PageParams;
  title?: string;
  showInfo?: boolean;
};

export default function ScoreCardHeader(props: Props) {
  const T = useT();
  const { title, showInfo = false } = props;

  return (
    <div className={styles.scoreHeader}>
      <div className={styles.scoreHeaderTop}>
        <h2 className={cardStyles.title}>{title || T(TKey.CLIENT_AVATAR_DETAIL_SCORE_TITLE)}</h2>
      </div>
      {showInfo && (
        <span className={styles.scoreInfo}>
          <IconSparkles size={14} />
          {T(TKey.CLIENT_AVATAR_DETAIL_SCORE_INFO)}
        </span>
      )}
    </div>
  );
}
